(function(){

const TOTAL_DURATION_MS = 18000;
const HOLD_MS_SHORT_TEXT = 5200;
const GAP_MS = 250;

const MESSAGES = [
  "Delivery all over Lebanon!",
  "Certified safe for your baby's health!",
  "Top quality products from the best factories!",
  "Cash on delivery!",
  "Free returns — no worries!",
  "Order risk-free with BabySharkLB!"
];

function initBanner(){
  const banner=document.querySelector('.delivery-banner');
  const stage=banner?.querySelector('.db-stage');
  const msgEl=banner?.querySelector('#dbMsg');
  if(!banner||!stage||!msgEl) return;

  let index=0,animation=null;

  function next(){
    index=(index+1)%MESSAGES.length;
    setTimeout(run,GAP_MS);
  }

  function run(){
    if(animation) animation.cancel();

    msgEl.textContent=MESSAGES[index];

    const stageWidth=stage.clientWidth;
    const msgWidth=msgEl.scrollWidth;

    if(msgWidth<=stageWidth){
      const center=(stageWidth-msgWidth)/2;

      animation=msgEl.animate([
        {transform:`translateX(${center}px)`,opacity:0},
        {transform:`translateX(${center}px)`,opacity:1,offset:.1},
        {transform:`translateX(${center}px)`,opacity:1,offset:.9},
        {transform:`translateX(${center}px)`,opacity:0}
      ],{duration:HOLD_MS_SHORT_TEXT,easing:"ease-in-out"});

    }else{
      const start=stageWidth;
      const center=(stageWidth-msgWidth)/2;
      const end=stageWidth-msgWidth-5;

      animation=msgEl.animate([
        {transform:`translateX(${start}px)`,opacity:0},
        {transform:`translateX(${center}px)`,opacity:1,offset:.15},
        {transform:`translateX(${center}px)`,opacity:1,offset:.35},
        {transform:`translateX(${end}px)`,opacity:1,offset:.85},
        {transform:`translateX(${end}px)`,opacity:0}
      ],{duration:TOTAL_DURATION_MS,easing:"linear"});
    }

    animation.onfinish=next;
  }

  run();
  window.addEventListener('resize',run);
}

document.addEventListener('DOMContentLoaded',initBanner);
document.addEventListener('shopify:section:load',initBanner);

})();
